import React, { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { settingsAPI } from '../services/api';
import { useAuth } from './AuthContext';

const FinancialYearContext = createContext(null);

export const useFinancialYear = () => useContext(FinancialYearContext);

export const FinancialYearProvider = ({ children }) => {
  const { user, activeCompanyId } = useAuth();
  const [activeFY, setActiveFY] = useState(null);
  const [fyLoading, setFyLoading] = useState(false);

  const refreshFinancialYear = useCallback(async () => {
    if (!user || !activeCompanyId) {
      setActiveFY(null);
      return;
    }
    setFyLoading(true);
    try {
      const res = await settingsAPI.getFinancialYears();
      const active = (res.data || []).find((fy) => fy.is_active) || null;
      setActiveFY(active);
    } catch {
      setActiveFY(null);
    } finally {
      setFyLoading(false);
    }
  }, [user, activeCompanyId]);

  useEffect(() => {
    refreshFinancialYear();
  }, [refreshFinancialYear]);

  return (
    <FinancialYearContext.Provider value={{ activeFY, fyLoading, refreshFinancialYear }}>
      {children}
    </FinancialYearContext.Provider>
  );
};
